"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PXWidgetState_1 = require("../../../Extendables/PXWidgetState");
class SelectorWidgetState extends PXWidgetState_1.default {
    getContactMethods() {
        return this.get("contact_methods");
    }
    setContactMethods(methods) {
        this.set("contact_methods", methods);
        return this;
    }
    getDealers() {
        return this.get("dealers");
    }
    setDealers(dealers) {
        this.set("dealers", dealers);
        return this;
    }
    getIsLoading() {
        return this.get("is_loading");
    }
    setIsLoading(isLoading) {
        this.set("is_loading", isLoading);
        return this;
    }
    setBackButtonDisplay(display) {
        this.set("backButtonDisplay", display);
        return this;
    }
    getCustomer() {
        return this.get("customer");
    }
    setCustomer(customer) {
        this.set("customer", customer);
        return this;
    }
    setErrorCode(errorCode) {
        this.set("errorCode", errorCode);
        return this;
    }
    getErrorMessage() {
        return this.get("errorMessage");
    }
    setErrorMessage(errorMessage) {
        this.set("errorMessage", errorMessage);
        return this;
    }
    setExceptionContextMessage(contextMessage) {
        this.set("exceptionContextMessage", contextMessage);
        return this;
    }
    setOptionalExtras(extras) {
        this.set("optional_extras", extras);
        return this;
    }
    setQuestionnaire(questionnaireType, questionnaire) {
        this.set(`questionnaires_${questionnaireType}`, questionnaire);
        return this;
    }
    getQuestionnaire(questionnaireType) {
        return this.get(`questionnaires_${questionnaireType}`);
    }
    setQuestionnaireAnswers(questionnaireType, answers) {
        this.set(`answers_${questionnaireType}`, answers);
        return this;
    }
    getQuestionnaireAnswers(questionnaireType) {
        return this.get(`answers_${questionnaireType}`);
    }
    setVrm(value) {
        this.set("vrm", value);
        return this;
    }
    getVehicleSearchPreloadRequired() {
        return this.get('vehicleSearchPreloadRequired');
    }
    setVehicleSearchPreloadRequired(value) {
        this.set("vehicleSearchPreloadRequired", value);
        return this;
    }
    setVrnOnlySearchFailed(value) {
        this.set("vrnOnlySearchFailed", value);
        return this;
    }
    getVehicleOptionType(vehicleOptionType) {
        return this.get(vehicleOptionType);
    }
    getIncompleteInfo() {
        return this.get('incompleteInfo');
    }
    setIncompleteInfo(value) {
        this.set("incompleteInfo", value);
        return this;
    }
    setTriedVrm(value) {
        this.set("triedVrm", value);
        return this;
    }
    getCurrentOption() {
        return this.get('currentOption');
    }
    setCurrentOption(value) {
        this.set("currentOption", value);
        return this;
    }
    setVehicleOptionType(vehicleOptionType, value) {
        this.set(vehicleOptionType, value);
        return this;
    }
    getVehicleOptions(vehicleOptionType) {
        return this.get(vehicleOptionType + '_OPTIONS');
    }
    setVehicleOptions(vehicleOptionType, value) {
        this.set(vehicleOptionType + '_OPTIONS', value);
        return this;
    }
    setVehicleOptionTypeLabel(vehicleOptionType, value) {
        this.set(vehicleOptionType + '_LABEL', value);
        return this;
    }
    setVehicleOptionTypeError(optionType, value) {
        this.set(optionType + '_ERROR', value);
        return this;
    }
    setErrorStatus(errorStatus) {
        this.set('ERROR_STATUS', errorStatus);
        return this;
    }
    getVehicles() {
        return this.get('vehicles');
    }
    setVehicles(vehicles) {
        this.set('vehicles', vehicles);
        return this;
    }
    setIsReturnFromLink(returnToken) {
        this.set('isReturnFromLink', returnToken);
        return this;
    }
    setQuestionnairesFinal(questionnaire) {
        this.set('questionnaires_final', questionnaire);
        return this;
    }
    setUserNextStepChoice(choice) {
        this.set('user_next_step_choice', choice);
        return this;
    }
    getUserNextStepChoice() {
        return this.get('user_next_step_choice');
    }
    setFinalQuestionnaireAnswers(answers) {
        this.set('answers_final', answers);
        return this;
    }
    getFinalQuestionnaireAnswers() {
        return this.get('answers_final');
    }
    setToken(token) {
        this.set('token', token);
        return this;
    }
    setMileage(mileage) {
        this.set('mileage', mileage);
        return this;
    }
    setStatus(status) {
        this.set('status', status);
        return this;
    }
    setVrmInvalid(value) {
        this.set('VRM_INVALID', value);
        return this;
    }
    getNextStepAnswersEnum() {
        return this.get('nextStepAnswersEnum');
    }
    setNextStepAnswersEnum(nextStepAnswers) {
        this.set('nextStepAnswersEnum', nextStepAnswers);
        return this;
    }
    setRangedValuationPrice(value = true) {
        this.set('isRangedValuationPrice', value);
        return this;
    }
    setPriceColor(value) {
        this.set('priceColor', value);
        return this;
    }
    setValuationMinPrice(value) {
        this.set('valuationMinPrice', value);
        return this;
    }
    setValuationMaxPrice(value) {
        this.set('valuationMaxPrice', value);
        return this;
    }
    isAustraliaDistribution() {
        return this.get('isAustraliaDistribution');
    }
    setIsAustraliaDistribution(isAustralia) {
        this.set('isAustraliaDistribution', isAustralia);
        return this;
    }
}
exports.default = SelectorWidgetState;
